@if (ready) {
  <app-codemirror
    [bare]="true"
    [extensions]="extensions"
    (focusChange)="focusChanged($event)"
    [(ngModel)]="value"
  />
}
